import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { loadThemeChoice, saveThemeChoice, type ThemeChoice } from '../theme.js';
import { setLocale } from '../i18n/index.js';

/**
 * «Профиль»: план и норма, тема, язык, аккаунт.
 * Этап 0: рабочие переключатели темы и языка, остальное — каркас.
 */
export function ProfileScreen(): JSX.Element {
  const { t, i18n } = useTranslation();
  const [theme, setTheme] = useState<ThemeChoice>(() => loadThemeChoice());

  const pickTheme = (choice: ThemeChoice): void => {
    setTheme(choice);
    saveThemeChoice(choice);
  };

  const themes: Array<{ value: ThemeChoice; label: string }> = [
    { value: 'dark', label: t('profile.themeDark') },
    { value: 'light', label: t('profile.themeLight') },
    { value: 'system', label: t('profile.themeSystem') },
  ];

  return (
    <main className="screen">
      <h1 className="type-h1 screen-title">{t('profile.title')}</h1>

      <section className="card">
        <p className="type-micro-11 card-label">{t('profile.plan')}</p>
        <p className="type-body-15 muted" style={{ margin: 0 }}>
          {t('profile.planStub')}
        </p>
      </section>

      <section className="card">
        <p className="type-micro-11 card-label">{t('profile.theme')}</p>
        <div className="segmented" role="radiogroup" aria-label={t('profile.theme')}>
          {themes.map((th) => (
            <button
              key={th.value}
              type="button"
              role="radio"
              aria-checked={theme === th.value}
              className={theme === th.value ? 'active' : undefined}
              onClick={() => pickTheme(th.value)}
            >
              {th.label}
            </button>
          ))}
        </div>
      </section>

      <section className="card">
        <p className="type-micro-11 card-label">{t('profile.language')}</p>
        <div className="segmented" role="radiogroup" aria-label={t('profile.language')}>
          {(['ru', 'en'] as const).map((lng) => (
            <button
              key={lng}
              type="button"
              role="radio"
              aria-checked={i18n.language === lng}
              className={i18n.language === lng ? 'active' : undefined}
              onClick={() => setLocale(lng)}
            >
              {lng === 'ru' ? 'Русский' : 'English'}
            </button>
          ))}
        </div>
      </section>

      <section className="card">
        <p className="type-micro-11 card-label">{t('profile.account')}</p>
        <p className="type-body-15 muted" style={{ margin: 0 }}>
          {t('profile.accountStub')}
        </p>
      </section>
    </main>
  );
}
